import React from 'react';
import { Container, Typography, Box, Button } from '@material-ui/core';

function Agradecimento() {
  return (
    <div maxWidth="sm" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',  }}>
      <div
        style={{
          padding: '30px',
          borderRadius: '8px',
          backgroundColor: '#fff',
          divShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', // Sombra difusa
          textAlign: 'center',
          
        }}
      >
        <Typography variant="h4" gutterBottom>
          Agradecemos pelo seu cadastro!
        </Typography>
        <Typography variant="body1" paragraph>
          Seu cadastro foi realizado com sucesso. Em breve, você receberá mais
          informações sobre os próximos passos.
        </Typography>
       
      </div>
    </div>
  );
}

export default Agradecimento;
